import { createSlice } from "@reduxjs/toolkit";

const LoginSlice = createSlice({
  name: "partner",
  initialState: {
    partner: null,
    stores: null,
  },
  reducers: {
    LoginSuccess: (state, action) => {
      state.partner = action.payload;
    },
    storesSuccess: (state, action) => {
      state.stores = action.payload;
    },
    Logout: (state) => {
      state.partner = null;
      state.stores = null;
    },
  },
});

export const { LoginSuccess, Logout, storesSuccess } = LoginSlice.actions;
export default LoginSlice.reducer;
